import { DatePicker, TimeRangePickerProps } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";

const { RangePicker } = DatePicker;

interface DateRangePickerProps {
    value?: [Dayjs | null, Dayjs | null];
    onChange?: (range: [Dayjs | null, Dayjs | null]) => void;
    allowClear?: boolean;
    showTime?: boolean;
}

export const DateRangePicker = ({ value, onChange, allowClear = false, showTime = false }: DateRangePickerProps) => {
    const { t } = usePaldockTranslation("ui.date-range-picker");

    const handleChange: TimeRangePickerProps["onChange"] = (dates) => {
        if (!dates) {
            onChange?.([null, null]);
            return;
        }
        onChange?.([dates[0], dates[1]]);
    };

    const presets: TimeRangePickerProps["presets"] = [
        { label: t("today"), value: [dayjs().startOf("day"), dayjs().endOf("day")] },
        {
            label: t("yesterday"),
            value: [dayjs().subtract(1, "day").startOf("day"), dayjs().subtract(1, "day").endOf("day")],
        },
        { label: t("this_week"), value: [dayjs().startOf("week"), dayjs().endOf("day")] },
        {
            label: t("last_week"),
            value: [dayjs().subtract(1, "week").startOf("week"), dayjs().subtract(1, "week").endOf("week")],
        },
        { label: t("this_month"), value: [dayjs().startOf("month"), dayjs().endOf("day")] },
        {
            label: t("last_month"),
            value: [dayjs().subtract(1, "month").startOf("month"), dayjs().subtract(1, "month").endOf("month")],
        },
        { label: t("last_7_days"), value: [dayjs().subtract(6, "day").startOf("day"), dayjs().endOf("day")] },
        { label: t("last_30_days"), value: [dayjs().subtract(29, "day").startOf("day"), dayjs().endOf("day")] },
        { label: t("last_90_days"), value: [dayjs().subtract(89, "day").startOf("day"), dayjs().endOf("day")] },
        {
            label: t("last_12_months"),
            value: [dayjs().subtract(1, "year").add(1, "day").startOf("day"), dayjs().endOf("day")],
        },
    ];

    return (
        <RangePicker
            value={value}
            presets={presets}
            onChange={handleChange}
            allowClear={allowClear}
            showTime={showTime}
        />
    );
};
